import Box from "@mui/material/Box";
import "../../index.css";
import StaffTable from "../../components/common/table";
import { StaffEditModel } from "./staff_edit_model";
import { StaffHeader } from "../../utils/headers";
import ViewIcon from "../../assets/icon/ViewIcon.svg";
import KeyIcon from "../../assets/icon/keyIcon.svg";
import EditIcon from "../../assets/icons/edit.svg";
import ProfileImage from "../../assets/images/profileImage.svg";
import BlockModel from "../common/BlockModel";
import { useEffect, useState } from "react";
import BlockIcon from "../../assets/icon/RedIcon.svg";
import UnBlockIcon from "../../assets/icon/unBlock.svg";
import PinIcon from "../../assets/icon/pinicon.svg";
import ToolTip from "../common/ToolTip";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { staffStatus, reset } from "../../features/staff/staffSlice";
import NoDataMessage from "../common/NoDataMessage";
import { Roles } from "../../utils/constants";

interface IProps {
  pharmacy_id: any;
  GetAllStaffPermissions: () => void;
  setOpenSnackEditbar: any;
  setOpenErrorToast: any;
  searchQuery: any;
  requiredFilters: any;
}

const AllStaff = ({
  pharmacy_id,
  GetAllStaffPermissions,
  setOpenSnackEditbar,
  setOpenErrorToast,
  searchQuery,
  requiredFilters,
}: IProps) => {
  const {
    staffPermissionsPayload,
    isStaffStatusLoading,
    isStaffStatusError,
    staffStatusMessage,
  }: any = useAppSelector((state) => state.staff);

  // Log the data properly

  const [filterData, setFilterData] = useState<any>([]);

  useEffect(() => {
    const filterDataFunction = ({
      dropdown1,
      dropdown2,
      dropdown3,
    }: any) => {
      return staffPermissionsPayload
        ?.map((item: any) => {
          const matchSearch = searchQuery
            ? item?.staff?.name
              .toLowerCase()
              .includes(searchQuery?.toLowerCase()) ||
            Roles[item?.credentials?.role]
              ?.toLowerCase()
              .includes(searchQuery?.toLowerCase()) ||
            item?.staff?.contact_number?.includes(searchQuery)
            : true;
          const matchesName = dropdown1
            ? item?.staff?.name.toLowerCase().includes(dropdown1.toLowerCase())
            : true;

          // const matchesDate = date ? item.updated_at.includes(date) : true;
          const matchesRole = dropdown2
            ? Roles[item?.credentials?.role]?.toLowerCase() ===
            dropdown2?.toLowerCase()
            : true;

          const matchesPhone = dropdown3
            ? item?.staff?.contact_number?.includes(dropdown3)
            : true;

          if (matchSearch && matchesName && matchesRole && matchesPhone) {
            return {
              name: item.staff.name,
              role_id: item.credentials.role,
              pin: item.credentials.pin,
              isActive: item.credentials.isActive,
              avatar: ProfileImage,
              contact_number: item.staff.contact_number,
              address: item.staff.address,
              email: item.staff.email,
              id: parseInt(item.staff.id),
              gender: item.staff.gender,
            };
          }
          return null; // Return null if the filter condition is not met
        })
        .filter((item: any) => item !== null && item); // Remove any null entries from the final result
    };

    const filteredData = filterDataFunction(requiredFilters);
    setFilterData(filteredData ? filteredData : []);
  }, [requiredFilters, searchQuery]);

  const dispatch = useAppDispatch();
  const renderActions = (item: any) => (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        padding:"0px 0px"
      }}
    >
      <StaffEditModel
        item={item}
        img={ViewIcon}
        type="View"
        title="View"
        GetAllStaffPermissions={GetAllStaffPermissions}
        setOpenSnackEditbar={setOpenSnackEditbar}
        setOpenErrorToast={setOpenErrorToast}
      />

      <StaffEditModel
        item={item}
        img={EditIcon}
        type="Edit"
        title="Edit"
        GetAllStaffPermissions={GetAllStaffPermissions}
        setOpenSnackEditbar={setOpenSnackEditbar}
        setOpenErrorToast={setOpenErrorToast}
      />
      <ToolTip
        width="18px"
        height={"18px"}
        IconType={!item?.isActive ? UnBlockIcon : BlockIcon}
        title={!item?.isActive ? "UnBlock" : "Block"}
        onClick={() => handleOpen(item)}
        style={{ cursor: "pointer" }}
      // disabled={!item?.isActive}
      />
      <StaffEditModel
        item={item}
        img={PinIcon}
        type="PinIcon"
        title={"Edit Pin"}
        GetAllStaffPermissions={GetAllStaffPermissions}
        setOpenSnackEditbar={setOpenSnackEditbar}
        setOpenErrorToast={setOpenErrorToast}
      />
      <StaffEditModel
        item={item}
        img={KeyIcon}
        type="Key"
        title="Edit Permissions"
        GetAllStaffPermissions={GetAllStaffPermissions}
        setOpenSnackEditbar={setOpenSnackEditbar}
        setOpenErrorToast={setOpenErrorToast}
      />
    </Box>
  );

  const [currentName, setCurrentName] = useState("");

  const [staffItem, setStaffItem] = useState<any>(null);

  const [open, setOpen] = useState(false);
  const handleOpen = (item: any) => {
    setCurrentName(item.name);
    setStaffItem(item);
    setOpen(true);
  };

  const handleBlock = () => {
    const obj = {
      id: staffItem?.id,
      pharmacy_id: parseInt(pharmacy_id),
      isActive: !staffItem?.isActive ? true : false,
    };

    dispatch(staffStatus(obj)).then((res: any) => {
      if (res.payload.success === true) {
        handleClose();
        setOpenSnackEditbar(true);
        GetAllStaffPermissions();
      } else {
        setOpenErrorToast(true);
      }
    });
  };

  const handleClose = () => {
    setOpen(false);
    setCurrentName("");
  };
  return (
    <>
      {filterData?.length === 0 || filterData === undefined ? (
        <NoDataMessage />
      ) : (
        <StaffTable
          headers={StaffHeader}
          data={filterData ? [...filterData].reverse() : null}
          Actions={renderActions}
        />
      )}

      <BlockModel
        open={open}
        onClose={handleClose}
        currentName={currentName}
        onBlock={handleBlock}
        isLoading={isStaffStatusLoading}
        error={isStaffStatusError}
        Message={staffStatusMessage}
        staffItem={staffItem}
      />
    </>
  );
};

export default AllStaff;
